import { createStore } from 'redux';
import thunk from 'redux-thunk';

import { applyMiddleware } from 'helpers/redux_dev_tools';
import reducer from './reducer';

export default function (state) {
  const store = createStore(reducer, state, applyMiddleware(thunk));

  if (module.hot) {
    module.hot.accept('./reducer', () => {
      store.replaceReducer(require('./reducer'));
    });
  }

  return store;
}
